import { ComponentData } from '@/types/component-from-page'

export const resistorData: ComponentData = {
  name: "1/4W 1% Metal Film Resistor",
  slug: "W%201%20Metal%20Film%20Resistor",
  category: "Passive Components",
  type: "Through-hole Resistor",
  partNumber: "MFR-25FBF52-10K",
  description: "A high-precision, low-noise 10kΩ resistor suitable for various electronic applications.",
  specifications: [
    { name: "Resistance", value: 10000, unit: "Ω" },
    { name: "Tolerance", value: 1, unit: "%" },
    { name: "Power Rating", value: 0.25, unit: "W" },
    { name: "Temperature Coefficient", value: 100, unit: "ppm/°C" },
    { name: "Operating Temperature", value: "-55 to +155", unit: "°C" },
    { name: "Length", value: 6.3, unit: "mm" },
    { name: "Diameter", value: 2.3, unit: "mm" },
  ],
  compatibility: {
    standards: ["RoHS Compliant", "REACH Compliant"],
    interchangeability: ["Any 1/4W 10kΩ 1% resistor"],
    applications: ["Voltage Dividers", "Current Limiting", "Pull-up/Pull-down Circuits", "Analog Filters"],
  },
  supplyChain: {
    manufacturer: "Yageo",
    distributor: "Digi-Key Electronics",
    availability: "In Stock",
    priceRange: "$0.10 - $0.05 (1000+ qty)",
  },
  resources: [
    { name: "Datasheet", url: "https://www.yageo.com/upload/media/product/products/datasheet/lr/Yageo_LR_MFR_1.pdf", type: "pdf" },
    { name: "Application Note", url: "https://www.yageo.com/upload/media/product/products/appnote/Yageo_AN_Thermal_Considerations_for_Resistors.pdf", type: "pdf" },
  ],
  images: [
    "/placeholder.svg?height=300&width=300",
    "/placeholder.svg?height=300&width=300",
  ],
  schematicUrl: "/placeholder.svg?height=300&width=300",
  tags: ["Resistor", "10kΩ", "1%", "Metal Film", "Through-hole"],
  sku: "MFR-25FBF52-10K",
  customFields: {
    "Internal Part Number": "R-TH-10K-1%-25",
    "Preferred Vendor": "Digi-Key",
  },
  url: '/component/resistor/Metal%20Film%20Resistor',
  manufacturerUrl: '/manufacturer/Yageo',
  supplierUrl: '/supplier/Digi-Key%20Electronics'
}

export const capacitorData: ComponentData = {
  name: "10uF Ceramic Capacitor",
  slug: "10uF%20Ceramic%20Capacitor",
  category: "Passive Components",
  type: "SMD Capacitor",
  partNumber: "CL31A106KAHNNNE",
  description: "A surface-mount ceramic capacitor with high capacitance and low ESR.",
  specifications: [
    { name: "Capacitance", value: 10, unit: "µF" },
    { name: "Voltage Rating", value: 25, unit: "V" },
    { name: "Tolerance", value: 10, unit: "%" },
    { name: "Temperature Coefficient", value: "X7R" },
    { name: "Operating Temperature", value: "-55 to +125", unit: "°C" },
    { name: "Size", value: "1206" },
  ],
  compatibility: {
    standards: ["RoHS Compliant", "REACH Compliant"],
    interchangeability: ["Any 10µF 25V X7R 1206 capacitor"],
    applications: ["Decoupling", "Filtering", "Timing Circuits"],
  },
  supplyChain: {
    manufacturer: "Samsung Electro-Mechanics",
    distributor: "Mouser Electronics",
    availability: "In Stock",
    priceRange: "$0.15 - $0.08 (1000+ qty)",
  },
  resources: [
    { name: "Datasheet", url: "https://www.samsungsem.com/resources/file/global/support/product/catalog/MLCC.pdf", type: "pdf" },
  ],
  images: [
    "/placeholder.svg?height=300&width=300",
    "/placeholder.svg?height=300&width=300",
  ],
  schematicUrl: "/placeholder.svg?height=300&width=300",
  tags: ["Capacitor", "10µF", "Ceramic", "SMD", "X7R"],
  sku: "CL31A106KAHNNNE",
  customFields: {
    "Internal Part Number": "C-SMD-10UF-25V-X7R",
    "Preferred Vendor": "Mouser",
  },
  url: '/component/capacitor/10uF%20Ceramic%20Capacitor',
  manufacturerUrl: '/manufacturer/Samsung%20Electro-Mechanics',
  supplierUrl: '/supplier/Mouser%20Electronics'
}

export const ballBearingData: ComponentData = {
  name: "Stainless Steel Ball Bearing",
  slug: "stainless-steel-ball-bearing",
  category: "Mechanical Components",
  type: "Radial Ball Bearing",
  partNumber: "6200-2RS",
  description: "A sealed, single row deep groove ball bearing suitable for various mechanical applications.",
  specifications: [
    { name: "Inner Diameter", value: 10, unit: "mm" },
    { name: "Outer Diameter", value: 30, unit: "mm" },
    { name: "Width", value: 9, unit: "mm" },
    { name: "Dynamic Load Rating", value: 5070, unit: "N" },
    { name: "Static Load Rating", value: 2360, unit: "N" },
    { name: "Maximum Speed", value: 32000, unit: "rpm" },
  ],
  compatibility: {
    standards: ["ISO 15", "DIN 625-1"],
    interchangeability: ["Any 6200-2RS bearing"],
    applications: ["Electric Motors", "Pumps", "Conveyor Systems", "Automotive"],
  },
  supplyChain: {
    manufacturer: "SKF",
    distributor: "Motion Industries",
    availability: "In Stock",
    priceRange: "$8.50 - $6.20 (100+ qty)",
  },
  resources: [
    { name: "Datasheet", url: "https://www.skf.com/binaries/pub12/Images/0901d196802809de-Rolling-bearings---17000_1-EN_tcm_12-121486.pdf", type: "pdf" },
    { name: "Installation Guide", url: "https://www.skf.com/binaries/pub54/Images/0901d1968024acef-SKF-bearing-installation-and-maintenance-guide_tcm_54-129877.pdf", type: "pdf" },
  ],
  images: [
    "/placeholder.svg?height=300&width=300",
    "/placeholder.svg?height=300&width=300",
  ],
  modelUrl: "https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/master/2.0/Box/glTF/Box.gltf",
  tags: ["Ball Bearing", "Stainless Steel", "Sealed", "Radial"],
  sku: "6200-2RS-SKF",
  customFields: {
    "Internal Part Number": "BB-6200-2RS-SS",
    "Lubrication": "Grease",
    "Sealing": "Double Sealed (2RS)",
  },
  url: '/component/ballBearing/Stainless%20Steel%20Ball%20Bearing',
  manufacturerUrl: '/manufacturer/SKF',
  supplierUrl: '/supplier/Motion%20Industries'
}

export const gearData: ComponentData = {
  name: "Spur Gear",
  slug: "spur-gear",
  category: "Mechanical Components",
  type: "Transmission Gear",
  partNumber: "S1224B",
  description: "A precision-machined spur gear for power transmission in various mechanical systems.",
  specifications: [
    { name: "Number of Teeth", value: 24 },
    { name: "Pitch", value: 12, unit: "DP" },
    { name: "Pressure Angle", value: 20, unit: "°" },
    { name: "Bore Diameter", value: 0.25, unit: "in" },
    { name: "Outside Diameter", value: 2.167, unit: "in" },
    { name: "Face Width", value: 0.5, unit: "in" },
    { name: "Material", value: "Brass" },
  ],
  compatibility: {
    standards: ["AGMA 2000-A88"],
    interchangeability: ["Any 24T 12DP spur gear with 0.25in bore"],
    applications: ["Industrial Machinery", "Robotics", "Automotive", "Precision Instruments"],
  },
  supplyChain: {
    manufacturer: "Boston Gear",
    distributor: "McMaster-Carr",
    availability: "In Stock",
    priceRange: "$25.60 - $22.80 (10+ qty)",
  },
  resources: [
    { name: "Datasheet", url: "https://www.bostongear.com/-/media/files/literature/product-catalogs/p-1930-bg-sections/p-1930-bg_spur-gears.ashx", type: "pdf" },
    { name: "CAD Model", url: "https://www.bostongear.com/products/open-gearing/spur-gears/brass-spur-gears/nb24b", type: "cad" },
  ],
  images: [
    "/placeholder.svg?height=300&width=300",
    "/placeholder.svg?height=300&width=300",
  ],
  modelUrl: "https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/master/2.0/Box/glTF/Box.gltf",
  tags: ["Spur Gear", "Brass", "24 Teeth", "12 DP"],
  sku: "S1224B-BG",
  customFields: {
    "Internal Part Number": "GR-SPUR-24T-12DP-BRASS",
    "Gear Quality": "AGMA Class 10",
    "Hub Projection": "Single",
  },
  url: '/component/gear/Spur%20Gear',
  manufacturerUrl: '/manufacturer/Boston%20Gear',
  supplierUrl: '/supplier/McMaster-Carr'
}

export const componentList = [
  resistorData,
  capacitorData,
  ballBearingData,
  gearData
]